import * as actionTypes from '../types/waste';

const initialState = {
  wasteRolls: [],
  loading: false,
  okRequest: false,
  averageWaste: 0
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_WASTE_ROLLS:
      return {
        ...state,
        okRequest: false,
        loadingData: true
      };
    case actionTypes.GET_WASTE_ROLLS_SUCCESS:
      return {
        ...state,
        wasteRolls: payload.semiProducts,
        averageWaste: payload.averageWaste,
        okRequest: true,
        loadingData: false
      };
    case actionTypes.GET_WASTE_ROLLS_FAIL:
      return {
        ...state,
        loadingData: false
      };
    default:
      return state;
  }
};

export default reducer;
